// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profileImage {
  width: 94.81px;
  height: 94.81px;
  border-radius: 103.7px;
}

.profileName {
  font-family: Inter;
  font-size: 24px;
  font-weight: 600;
  line-height: 38px;
  text-align: left;
  color: #2c2c2c;
}

.profileDesignation {
  font-family: Karla;
  font-size: 15px;
  font-weight: 400;
  line-height: 21px;
  text-align: left;
  color: #404040;
}

.editImageIcon {
  width: 23.7px;
  height: 23.7px;
  top: 87px;
  left: 100px;
  padding: 5.93px;
  background: #323e4a;
}

.password_policy_heading {
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 15px;
  letter-spacing: 0.1599999964px;
  text-align: left;
  color: #45852e;
}

.collapsible_box {
  font-family: Inter;
}
.collapsible_box > input[type=checkbox] {
  display: none;
}
.collapsible_box > input[type=checkbox]:checked + label {
  color: #3a7425;
  background-color: #e4eae3;
}
.collapsible_box > input[type=checkbox]:checked + label::after {
  content: "";
  width: 20px;
  height: 2px;
  background-color: #45852e;
  border-radius: 10px;
}
.collapsible_box > input[type=checkbox]:checked + label + .form_fields {
  max-height: fit-content;
  padding: 0px;
  margin-top: 10px;
}
.collapsible_box .collapsible_box_label {
  background-color: #f3f3f3;
  border-radius: 6px;
  padding: 15px;
  font-family: Inter;
  font-size: 18px;
  font-weight: 500;
  line-height: 30px;
  letter-spacing: -0.02em;
  text-align: left;
  color: #4c4c4c;
  cursor: pointer;
}
.collapsible_box .collapsible_box_label::after {
  content: "+";
  font-size: 24px;
  font-weight: bold;
  width: 20px;
}
.collapsible_box .form_fields {
  max-height: 0;
  overflow: hidden;
  line-height: 26px;
  padding: 0px;
  transition: max-height 0.8s, padding 0.5s;
}

.change_password_heading {
  font-family: Inter;
  font-size: 19px;
  font-weight: 500;
  line-height: 30px;
  letter-spacing: -0.02em;
  text-align: left;
  color: #45852e;
}

.form-header-text {
  font-family: Inter;
  font-weight: 600;
}

.enterprise-profile .container {
  max-width: unset !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Profile%20section/Profile.scss","webpack://./src/components/Profile section/Profile.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,eAAA;EACA,sBAAA;ACCJ;;ADEA;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;ACCJ;;ADEA;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;ACCJ;;ADEA;EACI,aAAA;EACA,cAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;ACCJ;;ADEA;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,8BAAA;EACA,gBAAA;EACA,cAAA;ACCJ;;ADEA;EACI,kBAAA;ACCJ;ADAI;EACI,aAAA;ACER;ADAQ;EACI,cAAA;EACA,yBAAA;ACEZ;ADAY;EACI,WAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;ACEhB;ADEQ;EACI,uBAAA;EACA,YAAA;EACA,gBAAA;ACAZ;ADII;EACI,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;ACFR;ADIQ;EACI,YAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;ACFZ;ADMI;EACI,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,yCACI;ACLZ;;ADUA;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;ACPJ;;ADUA;EACI,kBAAA;EACA,gBAAA;ACPJ;;ADWI;EACI,2BAAA;ACRR","sourcesContent":[".profileImage {\n    width: 94.81px;\n    height: 94.81px;\n    border-radius: 103.7px;\n}\n\n.profileName {\n    font-family: Inter;\n    font-size: 24px;\n    font-weight: 600;\n    line-height: 38px;\n    text-align: left;\n    color: #2c2c2c;\n}\n\n.profileDesignation {\n    font-family: Karla;\n    font-size: 15px;\n    font-weight: 400;\n    line-height: 21px;\n    text-align: left;\n    color: #404040;\n}\n\n.editImageIcon {\n    width: 23.7px;\n    height: 23.7px;\n    top: 87px;\n    left: 100px;\n    padding: 5.93px;\n    background: #323e4a;\n}\n\n.password_policy_heading {\n    font-family: Inter;\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 15px;\n    letter-spacing: 0.1599999964237213px;\n    text-align: left;\n    color: #45852e;\n}\n\n.collapsible_box {\n    font-family: Inter;\n    > input[type='checkbox'] {\n        display: none;\n\n        &:checked + label {\n            color: #3a7425;\n            background-color: #e4eae3;\n\n            &::after {\n                content: '';\n                width: 20px;\n                height: 2px;\n                background-color: #45852e;\n                border-radius: 10px;\n            }\n        }\n\n        &:checked + label + .form_fields {\n            max-height: fit-content;\n            padding: 0px;\n            margin-top: 10px;\n        }\n    }\n\n    .collapsible_box_label {\n        background-color: #f3f3f3;\n        border-radius: 6px;\n        padding: 15px;\n        font-family: Inter;\n        font-size: 18px;\n        font-weight: 500;\n        line-height: 30px;\n        letter-spacing: -0.02em;\n        text-align: left;\n        color: #4c4c4c;\n        cursor: pointer;\n\n        &::after {\n            content: '+';\n            font-size: 24px;\n            font-weight: bold;\n            width: 20px;\n        }\n    }\n\n    .form_fields {\n        max-height: 0;\n        overflow: hidden;\n        line-height: 26px;\n        padding: 0px;\n        transition:\n            max-height 0.8s,\n            padding 0.5s;\n    }\n}\n\n.change_password_heading {\n    font-family: Inter;\n    font-size: 19px;\n    font-weight: 500;\n    line-height: 30px;\n    letter-spacing: -0.02em;\n    text-align: left;\n    color: #45852e;\n}\n\n.form-header-text {\n    font-family: Inter;\n    font-weight: 600;\n}\n\n.enterprise-profile {\n    .container {\n        max-width: unset !important;\n    }\n}\n",".profileImage {\n  width: 94.81px;\n  height: 94.81px;\n  border-radius: 103.7px;\n}\n\n.profileName {\n  font-family: Inter;\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 38px;\n  text-align: left;\n  color: #2c2c2c;\n}\n\n.profileDesignation {\n  font-family: Karla;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 21px;\n  text-align: left;\n  color: #404040;\n}\n\n.editImageIcon {\n  width: 23.7px;\n  height: 23.7px;\n  top: 87px;\n  left: 100px;\n  padding: 5.93px;\n  background: #323e4a;\n}\n\n.password_policy_heading {\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 15px;\n  letter-spacing: 0.1599999964px;\n  text-align: left;\n  color: #45852e;\n}\n\n.collapsible_box {\n  font-family: Inter;\n}\n.collapsible_box > input[type=checkbox] {\n  display: none;\n}\n.collapsible_box > input[type=checkbox]:checked + label {\n  color: #3a7425;\n  background-color: #e4eae3;\n}\n.collapsible_box > input[type=checkbox]:checked + label::after {\n  content: \"\";\n  width: 20px;\n  height: 2px;\n  background-color: #45852e;\n  border-radius: 10px;\n}\n.collapsible_box > input[type=checkbox]:checked + label + .form_fields {\n  max-height: fit-content;\n  padding: 0px;\n  margin-top: 10px;\n}\n.collapsible_box .collapsible_box_label {\n  background-color: #f3f3f3;\n  border-radius: 6px;\n  padding: 15px;\n  font-family: Inter;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 30px;\n  letter-spacing: -0.02em;\n  text-align: left;\n  color: #4c4c4c;\n  cursor: pointer;\n}\n.collapsible_box .collapsible_box_label::after {\n  content: \"+\";\n  font-size: 24px;\n  font-weight: bold;\n  width: 20px;\n}\n.collapsible_box .form_fields {\n  max-height: 0;\n  overflow: hidden;\n  line-height: 26px;\n  padding: 0px;\n  transition: max-height 0.8s, padding 0.5s;\n}\n\n.change_password_heading {\n  font-family: Inter;\n  font-size: 19px;\n  font-weight: 500;\n  line-height: 30px;\n  letter-spacing: -0.02em;\n  text-align: left;\n  color: #45852e;\n}\n\n.form-header-text {\n  font-family: Inter;\n  font-weight: 600;\n}\n\n.enterprise-profile .container {\n  max-width: unset !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
